// stores/selectionStore.js
import { writable } from "svelte/store";

const selectionStore = writable({
  selection: null,
  isInEditor: false,
});

export function useSelection() {
  // Save the current selection/cursor position
  function saveSelection(editor) {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      selectionStore.update((state) => ({
        ...state,
        selection: range.cloneRange(),
        isInEditor: editor.contains(selection.anchorNode),
      }));
    }
  }

  // Restore the saved selection/cursor position
  function restoreSelection() {
    let saved;
    selectionStore.update((state) => {
      saved = state;
      return state;
    });

    if (
      saved.selection &&
      saved.isInEditor &&
      document.body.contains(saved.selection.startContainer)
    ) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(saved.selection);
    }
  }

  return {
    saveSelection,
    restoreSelection,
  };
}
